<template>
  <div class="page">
    <ProductCardList
      ref="productCardList"
      :depConfig="depConfig"
      :showTabs="true"
    />
  </div>
</template>

<script>
import ProductCardList from "./ProductCardList.vue";
import { xcDepConfig } from "@/api/depConfig.js";
import { getDepNameByDomain } from "@/utils/index";

export default {
  name: "ProductCardListPage",
  components: {
    ProductCardList,
  },
  data() {
    return {
      depConfig: {},
    };
  },
  mounted() {
    this.getDepConfig();
  },
  methods: {
    getDepConfig() {
      const depName = getDepNameByDomain();
      xcDepConfig(depName).then((res) => {
        this.depConfig = res;
      });
    },
  },
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  background-color: #f7f7f9;
}
</style>



// WEBPACK FOOTER //
// src/view/productList/module/ProductCardListPage.vue